export default __webpack_public_path__ + "static/aiFeaturesBg-8e55d662b6233a6cf33e8395607f7136.png";